<template>
  <div class="cart-checkout-footer">
    <ul class="cart-checkout-footer__info-links footer-info-list">
      <li class="footer-info-list__item item">
        <a class="item__link" :href="links.legal" target="_blank">
          {{ $t('checkout.legal') }}
        </a>
      </li>
      <li class="footer-info-list__item item">
        <a class="item__link" :href="links.termsOfUse" target="_blank">
          {{ $t('footer.termsOfUseLabel') }}
        </a>
      </li>
      <li class="footer-info-list__item item">
        <a class="item__link" :href="links.termsOfSales" target="_blank">
          {{ $t('footer.termsOfSalesLabel') }}
        </a>
      </li>
      <li class="footer-info-list__item item">
        <a class="item__link" :href="links.privacyNoticeDoctors" target="_blank">{{
          $t('checkout.privacyNoticeDoctors')
        }}</a>
      </li>
      <li class="footer-info-list__item item">
        <a class="item__link" :href="links.privacyNoticePatients" target="_blank">{{
          $t('checkout.privacyNoticePatients')
        }}</a>
      </li>
    </ul>
    <p class="cart-checkout-footer__copyright">© {{ $t('checkout.allRightsReserved') }}</p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { types } from '@/store/types';

export default {
  name: 'CartCheckoutFooter',
  computed: {
    ...mapGetters({
      links: types.getters.FOOTER_LINKS
    })
  }
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/colors.scss';

.cart-checkout-footer {
  padding: 30px 16px 14px;
  color: var(--u-color-grey-500);
  border-top: 1px solid var(--u-color-grey-200);
  background-color: inherit;

  &__copyright {
    font-family: var(--u-font-family-Helvetica);
    font-size: 14px;
    font-weight: 400;
    line-height: 23px;
  }
}

.footer-info-list {
  font-family: var(--u-font-family-Gilroy);
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.75px;
  list-style-type: none;

  &__item {
    margin-bottom: 16px;
  }
}

.item {
  &__link {
    color: var(--u-color-grey-500);
    text-decoration: none;
  }
}

@media (min-width: 600px) {
  .footer-info-list {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: flex-start;
    max-height: 144px;

    &__item {
      margin-bottom: 24px;
    }
  }
}

@media (min-width: 960px) {
  .cart-checkout-footer {
    padding: 22px 40px 30px;
    background-color: $seashell-peach-color;

    &__info-links {
      margin-bottom: 17px;

      &:not(:first-child) {
        list-style-type: initial;
      }
    }
  }

  .footer-info-list {
    flex-direction: row;
    list-style-type: initial;

    &__item {
      margin-bottom: 0;
      margin-right: 6px;

      &:first-child {
        list-style-type: none;
      }
    }
  }

  .item {
    &__link {
      padding-right: 20px;
    }

    &:last-child {
      margin-right: 0;

      .item__link {
        padding: 0;
      }
    }
  }
}

@media (min-width: 1550px) {
  .cart-checkout-footer {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    padding: 30px 40px;

    &__info-links {
      margin-bottom: 0;
    }
  }
}
</style>
